import { createSelector } from 'reselect';
import get from 'lodash/get';
import identity from 'lodash/identity';
import { RootState } from '../../../stores/types';
import { AnalyticsState } from '../types';

// Returns the asynchronous state for the organization GMV timeline request.
export default createSelector<RootState, RootState, AnalyticsState['gmvByTimeline']['readyState']>(
  identity,
  (state) => get(state, 'analytics.gmvByTimeline.readyState'),
);
